import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { gameLiveConnection } from '../../module/gameLiveConnection/gameLiveConnection';
import { gameName } from '../../enums/gameConfigsAndUrls';
import { applicationStore } from '@pascal/pascal-core';
import { configStore } from '../../module/store/configStore';
import { observer } from 'mobx-react-lite';

export const SocketConnection = observer(() => {
  const { pathname } = useLocation();

  useEffect(() => {
    if(pathname.includes(gameName)) {
      gameLiveConnection.init().then(() => {
        gameLiveConnection.setConnectionListeners()
        gameLiveConnection.sendGetInitialState()
      })
    }
  }, [pathname, configStore.mode]);

  return <></>;
});
